<div class="form-group">
  <label><ng-container i18n>Address</ng-container></label>
  <input #search class="form-control" i18n-placeholder placeholder="Address" [ngModel]="address" (ngModelChange)="addressChange.emit($event)" />
</div>
